import type { Logger } from '@famecreator/websocket/core';

import { logger } from '@/shared/lib/logger';

/**
 * Adapter to connect the application logger with the websocket package
 */
export const websocketLoggerAdapter: Logger = {
  debug(message: string, context?: Record<string, unknown>): void {
    logger.websocket.debug(message, context);
  },

  info(message: string, context?: Record<string, unknown>): void {
    logger.websocket.info(message, context);
  },

  warn(message: string, context?: Record<string, unknown>): void {
    logger.websocket.warn(message, context);
  },

  error(message: string, context?: Record<string, unknown>): void {
    logger.websocket.error(message, context);
  },
};
